import { DEFAULT_CITY, DEFAULT_STATE } from 'spw-constants';

export const formatAddress = (location: {
  city?: string;
  state?: string;
  countryCode?: string;
}) => {
  if (location?.city === DEFAULT_CITY)
    return `${location.city}, ${DEFAULT_STATE}`;

  return (
    [
      location?.city,
      location?.countryCode === 'USA' || location?.countryCode === 'CAN'
        ? location?.state
        : null,
      location?.countryCode,
    ].reduce(
      (address, part, index) =>
        part && part.trim()
          ? `${address}${index !== 0 && address ? ', ' : ''}${part}`
          : address,
      ''
    ) || '--'
  );
};
